"use client";
import { Carousel } from "antd";
import useUIStore from '@/store/useUIStore';
import useMobileDetect from "@/hooks/useMobileDetect";
import { useState, useEffect, useMemo } from "react";
import { changeUrl, handleImgUrl, isHomePage } from "@/utils/tools";

type headerProps = {
  isFirst?: boolean,
};
export default function Index({
  isFirst = false,
}: headerProps) {
  const { affixStatus, updateAffixStatus } = useUIStore();
  const isMobile = useMobileDetect();

  const affixStatusValue = useMemo(() => {
    if (isFirst) {
      return affixStatus
    } else {
      return !isFirst
    }
  }, [isFirst, affixStatus])

  return <div
    className={`${affixStatusValue ? 'headerIsAffix' : 'text-white '}`}
    onMouseEnter={() => !isMobile && isHomePage() && updateAffixStatus(true)}
    onMouseLeave={() => !isMobile && isHomePage() && updateAffixStatus(false)}
  >

    <div className="h-36 text-center bravve3:hidden">
      <Carousel autoplay infinite waitForAnimate dots={false} dotPosition="left" className={`${affixStatusValue ? '' : 'text-white '}`}>
        <div className='h-36  leading-[3.6rem]'>
          <div className="flex items-center justify-center h-36">
            <iconpark-icon name="logistics" icon-id="logistics" color={affixStatusValue ? '#402C22' : "#fff"} size="2rem" class="mr-12" />Delivery Guarantee
          </div>
        </div>
        <div className='h-36  leading-[3.6rem] flex items-center'>
          <div className="flex items-center justify-center h-36">
            <iconpark-icon name="purse" icon-id="purse" color={affixStatusValue ? '#402C22' : "#fff"} size="2rem" class="mr-12" />Safe Payments
          </div>
        </div>
        <div className='h-36  leading-[3.6rem] flex items-center'>
          <div className="flex items-center justify-center h-36">
            <iconpark-icon name="eco-1" icon-id="eco-1" color={affixStatusValue ? '#402C22' : "#fff"} size="2rem" class="mr-12" />Environmentally and Healthy
          </div>
        </div>
      </Carousel>
    </div>

    <div >
      <div
        className='h-36 items-center justify-between hidden px-12 bravve3:flex lg:px-[4rem] contentMaxWidth'
      >
        <div className="flex items-center gap-x-10">
          {/* <Image src={sparkles} alt="sparkles" width={22} height={22} /> */}
          <h5>Timeless Elegance, Sustainable Living</h5>
        </div>
        <div className='flex gap-x-40'>
          <h3 className="flex items-center ">
            <iconpark-icon name="logistics" icon-id="logistics" color={affixStatusValue ? '#402C22' : "#fff"} size="2rem" class="mr-12" />Delivery Guarantee</h3>
          <h3 className="flex items-center ">
            <iconpark-icon name="purse" icon-id="purse" color={affixStatusValue ? '#402C22' : "#fff"} size="2rem" class="mr-12" />Safe Payments</h3>
          <h3 className="flex items-center ">
            <iconpark-icon name="eco-1" icon-id="eco-1" color={affixStatusValue ? '#402C22' : "#fff"} size="2rem" class="mr-12" />Environmentally and Healthy</h3>
        </div>
      </div>
    </div>
  </div>
}